import { LookupModel } from '../../../../api/models';
import { EventsFlowEventNodeTypes } from '../../models/events-flow-event-node-types';
import { EVENT_FLOW_FIELD_LABELS } from './event-flow-field-labels.const';

export const EVENT_FILTER_OPTIONS: Record<string, LookupModel[]> = {
  [EventsFlowEventNodeTypes.OnConnectToAgent]: [
    {
      id: 'extension',
      text: EVENT_FLOW_FIELD_LABELS['extension'],
    },
    {
      id: 'callFromAni',
      text: EVENT_FLOW_FIELD_LABELS['callFromAni'],
    },
    {
      id: 'callToAni',
      text: EVENT_FLOW_FIELD_LABELS['callToAni'],
    },
  ],
  [EventsFlowEventNodeTypes.OnNewCallIncoming]: [
    {
      id: 'callFromAni',
      text: EVENT_FLOW_FIELD_LABELS['callFromAni'],
    },
    {
      id: 'callToAni',
      text: EVENT_FLOW_FIELD_LABELS['callToAni'],
    },
  ],
  [EventsFlowEventNodeTypes.OnCallDetailRecord]: [
    {
      id: 'callType',
      text: EVENT_FLOW_FIELD_LABELS['callType'],
    },
    {
      id: 'callStatus',
      text: EVENT_FLOW_FIELD_LABELS['callStatus'],
    },
    {
      id: 'fromNumber',
      text: EVENT_FLOW_FIELD_LABELS['fromNumber'],
    },
    {
      id: 'toNumber',
      text: EVENT_FLOW_FIELD_LABELS['toNumber'],
    },
  ],

  [EventsFlowEventNodeTypes.OnRecordingAvailable]: [
    {
      id: 'callStatus',
      text: EVENT_FLOW_FIELD_LABELS['callStatus'],
    },
    {
      id: 'callType',
      text: EVENT_FLOW_FIELD_LABELS['callType'],
    },
    {
      id: 'fromNumber',
      text: EVENT_FLOW_FIELD_LABELS['fromNumber'],
    },
    {
      id: 'toNumber',
      text: EVENT_FLOW_FIELD_LABELS['toNumber'],
    },
    {
      id: 'recordings.account',
      text: EVENT_FLOW_FIELD_LABELS['recordings.account'],
    },
    {
      id: 'recordings.extension',
      text: EVENT_FLOW_FIELD_LABELS['recordings.extension'],
    },
  ],
};

export const UNIQUE_FILTER_LABELS = Object.values(EVENT_FILTER_OPTIONS)
  .flat()
  .reduce((acc, { id, text }) => {
    if (!acc[id]) {
      acc[id] = text;
    }
    return acc;
  }, {});
